import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClipboardCheck, Plus } from "lucide-react";
import { DataTable } from "../../components/data/DataTable";
import { NeuButton } from "../../components/neu/Neu";
import { listCounts } from "../../api/counts";
import { localName } from "../../lib/localName";

const STATE_COLORS = { draft: "amber", frozen: "sky", posted: "emerald", cancelled: "rose" };

// تبويب الجرد: قائمة + زر جديد — كل فتح ينتقل إلى صفحة مستقلة (لا نوافذ منبثقة).
export const WhCountsTab = ({ branchId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  useEffect(() => { listCounts({ branch_id: branchId || undefined })
    .then((d) => setRows(d.items || [])).catch(() => setRows([])); }, [branchId]);

  const cols = [
    { key: "number", label: t("warehouse.doc.number"),
      render: (r) => <span className="num font-mono font-bold text-teal-600">{r.number}</span> },
    { key: "wh", label: t("warehouse.count.warehouse"),
      render: (r) => <span className="text-xs">{localName(r.warehouse, "—")}</span> },
    { key: "type", label: t("warehouse.count.type"),
      render: (r) => <span className="text-[11px]">{t(`warehouse.count.types.${r.count_type}`)}</span> },
    { key: "date", label: t("warehouse.doc.date"),
      render: (r) => <span className="num font-mono">{r.date}</span> },
    { key: "state", label: t("warehouse.doc.state"),
      render: (r) => <span className={`rounded-full bg-${STATE_COLORS[r.state] || "slate"}-500/15 px-2 py-0.5 text-[10px] font-bold text-${STATE_COLORS[r.state] || "slate"}-700`}>
        {t(`warehouse.count.states.${r.state}`)}</span> },
    { key: "variances", label: t("warehouse.count.kpi.variances"),
      render: (r) => <span className="num font-mono text-xs">{(r.totals || {}).variances ?? 0}</span> },
    { key: "act", label: "",
      render: (r) => <NeuButton className="px-3 py-1 text-[11px]" data-testid={`cnt-open-${r.count_id}`}
        onClick={() => navigate(`/warehouse/counts/${r.count_id}`)}>
        {t("warehouse.count.open")}</NeuButton> },
  ];

  return (
    <div className="grid gap-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold">{t("warehouse.count.title")}</p>
        <NeuButton variant="primary" data-testid="cnt-new" disabled={!branchId}
                   onClick={() => navigate("/warehouse/counts/new")}
                   className="bg-teal-500 text-white hover:bg-teal-600">
          <Plus className="inline h-4 w-4" /> {t("warehouse.count.newTitle")}</NeuButton>
      </div>
      <DataTable testid="cnt-list" columns={cols} rows={rows} rowKey={(r) => r.count_id}
                 empty={!branchId ? t("warehouse.wh.pickBranch") : t("warehouse.count.empty")}
                 icon={<ClipboardCheck className="h-6 w-6 text-teal-500" />} />
    </div>
  );
};
